import moment from '@/utils/moment-wrapper.ts';
import { createGuide } from '@/guides/helpers/guide-editor.util.js';
import { EDITOR_TYPES } from '@pendo/services/Constants';
import { AiBlocks } from '@pendo/services/BuildingBlocks';
import { PendoNotification } from '@pendo/components';
import SegmentCardHelper from '@/guides/p2-guide-details/guide-settings/segment-card/segment-card-helper.js';
import { fromEvent, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import get from 'lodash/get';
import { isMobileApp } from '@/utils/apps';
import { TEMPLATE_TYPES } from '@/guides/helpers/templates/ai/index';

export async function convertArtifactToGuide (artifact, maxPriority, isTraining, theme, app, segments) {
    const DEFAULT_APP_ID = -323232;
    const appId = get(app, 'id', DEFAULT_APP_ID);
    const platform = app?.platform || 'web';
    const isMobile = isMobileApp(platform);
    const isEmbed = artifact.data.layoutType === TEMPLATE_TYPES.EMBEDDED;

    const guide = await createGuide({
        guideType: 'building-block',
        app: { id: appId },
        isMobile,
        maxPriority,
        skipAddStep: true,
        isTraining,
        editorType: EDITOR_TYPES.VDS,
        launchMethod: 'auto',
        name: artifact.data.guideName ?? `Unnamed ${moment().format('M/D [@] h:mm A')}`,
    });

    const steps = AiBlocks.updateGuideFromArtifact(artifact.data, [], {
        theme,
        platform,
        isEmbed,
    });

    guide.steps = steps;

    if (artifact.data.layoutType) {
        guide.layoutType = artifact.data.layoutType;
    }

    return addSegmentFromGuideArtifact(guide, artifact, app, segments);
};

export async function addSegmentFromGuideArtifact (guide, artifact, app, segments) {
    const segmentId = get(artifact, 'data.segment_id');
    if (!segmentId) return guide;

    const segment = segments[segmentId];
    if (!segment) return guide;

    const showGuidesToAnon = get(app, 'applicationFlags.showGuidesToAnon', false);
    const audienceConfig = {
        audienceUiHint: { filters: [{ kind: 'visitor', segmentId: artifact.data.segment_id }] },
    };

    const audience = await SegmentCardHelper.buildAudiencePipeline(audienceConfig.audienceUiHint.filters, { showGuidesToAnon });
    guide.audience = audience;
    guide.audienceUiHint = audienceConfig.audienceUiHint;

    return guide;
}

export function showGuideSavedNotification ({ guideId, router, title, linkText, position = 'top-right' }) {
    const duration = 5000;
    const linkId = `viewSavedGuideLink-${guideId}`;
    const notification = PendoNotification({
        type: 'success',
        duration,
        title,
        message: `<a id="${linkId}" href="#">${linkText} ›</a>`,
        dangerouslyUseHTMLString: true,
        position,
    });

    const guideLink = document.getElementById(linkId);

    if (!guideLink) return;

    fromEvent(guideLink, 'click')
        .pipe(takeUntil(timer(duration)))
        .subscribe(() => {
            router.push({
                name: 'GuideDetails',
                params: { guideId },
            });
            notification.close();
        });
}